/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  EngagementLetterResponse,
  MyProfileResponse,
  PeopleMeResponse,
} from "../models/index";
import {
  EngagementLetterResponseFromJSON,
  EngagementLetterResponseToJSON,
  MyProfileResponseFromJSON,
  MyProfileResponseToJSON,
  PeopleMeResponseFromJSON,
  PeopleMeResponseToJSON,
} from "../models/index";

/**
 *
 */
export class PeopleApi extends runtime.BaseAPI {
  /**
   * The caller\'s own engagement verification letter, as a base64 PDF. Self-scoped: the subject is always the authenticated caller (no id parameter), so no one can obtain anyone else\'s. The button is normally disabled until \\[MyProfileDetails.engagementLetterReady\\]; this still guards against a stale client with a clear 400.
   * The caller\'s own engagement verification letter, as a base64 PDF.
   */
  async engagementLetterRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<EngagementLetterResponse>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/people/me/engagement-letter`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      EngagementLetterResponseFromJSON(jsonValue),
    );
  }

  /**
   * The caller\'s own engagement verification letter, as a base64 PDF. Self-scoped: the subject is always the authenticated caller (no id parameter), so no one can obtain anyone else\'s. The button is normally disabled until \\[MyProfileDetails.engagementLetterReady\\]; this still guards against a stale client with a clear 400.
   * The caller\'s own engagement verification letter, as a base64 PDF.
   */
  async engagementLetter(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<EngagementLetterResponse> {
    const response = await this.engagementLetterRaw(initOverrides);
    return await response.value();
  }

  /**
   */
  async meRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PeopleMeResponse>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/people/me`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PeopleMeResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async me(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PeopleMeResponse> {
    const response = await this.meRaw(initOverrides);
    return await response.value();
  }

  /**
   */
  async myProfileRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<MyProfileResponse>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/people/me/profile`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      MyProfileResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async myProfile(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<MyProfileResponse> {
    const response = await this.myProfileRaw(initOverrides);
    return await response.value();
  }
}
